{
  "version": 1,
  "asset_id": "7b3cb552-8fa8-4db0-ab5c-4cb4682824eb",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/7b3cb552-8fa8-4db0-ab5c-4cb4682824eb/floral-city-black-shingle-roof-installation-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/7b3cb552-8fa8-4db0-ab5c-4cb4682824eb/floral-city-black-shingle-roof-installation-768w.avif",
  "original_filename": "floral-city-black-shingle-roof-installation-768w.avif",
  "size": 28540,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
